import apiClient from '@/services/api'

const ensureAssociateId = associate_id => {
  if (associate_id === undefined || associate_id === null || associate_id === '') {
    throw new Error('Associate ID is required')
  }

  return associate_id
}

export default {
  async getDocumentPlaceholders({ commit }) {
    try {
      const { data } = await apiClient.get('/api/document/placeholder')

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      commit('SET_PLACEHOLDERS', data.items)
    } catch (error) {
      throw error.message
    }
  },
  async getDocumentByType(_, { type, associate_id }) {
    try {
      const { data } = await apiClient.post('/api/document/project/type/get', {
        type,
        associate_id
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data.document
    } catch (error) {
      throw error.message
    }
  },

  async exportDocument({ rootState }, { export_type, ...rest }) {
    try {
      const { data } = await apiClient.post(`/api/document/project/export/${export_type}`, {
        ...rest,
        project_id: rootState.applicationState.currentProject.id
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data
    } catch (error) {
      throw error.message
    }
  },

  async backfillObject({ rootState }, { ...rest }) {
    try {
      const { data } = await apiClient.post('/api/document/project/backfill_object', {
        ...rest,
        project_id: rootState.applicationState.currentProject.id,
        author_id: rootState.applicationState.associate.id
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data
    } catch (error) {
      throw error.message
    }
  },

  async backfillBulkObject({ rootState }, { ...rest }) {
    try {
      const { data } = await apiClient.post('/api/document/project/backfill_object_multiple', {
        ...rest,
        project_id: rootState.applicationState.currentProject.id,
        author_id: rootState.applicationState.associate.id
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data
    } catch (error) {
      throw error.message
    }
  },

  async copyEntity({ rootState }, { object_id, type }) {
    const project_id = rootState.applicationState.currentProject.id

    try {
      await apiClient.post('/api/document/project/copy', {
        project_id,
        object_id,
        type
      })
    } catch (error) {
      throw error.message
    }
  },

  async getProjectDocuments({ rootState }, { filters, cancelPreviousRequests = true }) {
    try {
      const project_id = rootState.applicationState.currentProject.id

      const { data } = await apiClient.get(`/api/document/project/${project_id}`, {
        params: { ...filters },
        cancelPreviousRequests
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data
    } catch (error) {
      throw error.message
    }
  },

  async getDocumentsGroups({ rootState, commit }) {
    try {
      const { data } = await apiClient.post('/api/document/project/group/get_all', {
        project_id: rootState.applicationState.currentProject.id
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      commit('setGroups', data.groups)
    } catch (error) {
      throw error.message
    }
  },

  async getProjectDocument({ rootState, commit }, { document_id, version_number }) {
    try {
      const { data } = await apiClient.post('/api/document/project/get', {
        project_id: rootState.applicationState.currentProject.id,
        use_placeholder: false,
        document_id,
        version_number
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      commit('setDocument', data.document)

      return data.document
    } catch (error) {
      throw error.message
    }
  },

  async getPreviewDocument({ rootState }, { document_id, version_number }) {
    try {
      const { data } = await apiClient.post('/api/document/project/get', {
        project_id: rootState.applicationState.currentProject.id,
        associate_id: rootState.applicationState.associate.id,
        document_id,
        version_number
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data.document
    } catch (error) {
      throw error.message
    }
  },

  async getSignedDocument({ commit }, { document_id, associate_id, version }) {
    try {
      const { data } = await apiClient.get(`/api/document/${document_id}/associate/${associate_id}/signed`, {
        params: { version }
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      commit('setDocument', data.document)
    } catch (error) {
      throw error.message
    }
  },

  async createDocument({ rootState, commit }, { document }) {
    try {
      const { data } = await apiClient.post('/api/document/project/create', {
        project_id: rootState.applicationState.currentProject.id,
        document
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      commit('setDocument', data.document)

      return data.document
    } catch (error) {
      throw error.message
    }
  },

  async updateDocument({ rootState, commit }, { document }) {
    try {
      const { data } = await apiClient.post('/api/document/project/update', {
        project_id: rootState.applicationState.currentProject.id,
        document
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      commit('setDocument', data.document)

      return data.document
    } catch (error) {
      throw error.message
    }
  },

  async deleteDocument({ rootState }, { document_id }) {
    try {
      const { data } = await apiClient.post('/api/document/project/delete', {
        project_id: rootState.applicationState.currentProject.id,
        document_id
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }
    } catch (error) {
      throw error.message
    }
  },

  setAssociateDocuments({ commit }, payload) {
    commit('SET_ASSOCIATE_DOCUMENTS', payload)
  },

  async getAssociateDocuments({ commit }, { associate_id, page = 1, size = 10, name }) {
    try {
      const safeAssociateId = ensureAssociateId(associate_id)
      const { data } = await apiClient.get(`/api/document/associate/${safeAssociateId}/store`, {
        params: { page, size, name: name === '' ? undefined : name }
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg ?? 'An error occurred while loading the documents.'} `)
      }

      commit('SET_ASSOCIATE_DOCUMENTS', data)
    } catch (error) {
      throw error.message
    }
  },

  async getSyncAssociateDocuments({ commit }, { associate_id }) {
    try {
      const safeAssociateId = ensureAssociateId(associate_id)
      const { data } = await apiClient.get(`/api/document/associate/${safeAssociateId}/sync`)

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      commit('setAssociateDocumentsSync', data.document_sync)
    } catch (error) {
      throw error.message
    }
  },

  async postSyncAssociateDocuments({ commit }, { associate_id }) {
    try {
      const safeAssociateId = ensureAssociateId(associate_id)
      const { data } = await apiClient.post(`/api/document/associate/${safeAssociateId}/sync`)

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      commit('setAssociateDocumentsSync', data.document_sync)
    } catch (error) {
      throw error.message
    }
  },

  async getAssociateDocumentByRequest(_, { associate_id, request_id }) {
    try {
      const safeAssociateId = ensureAssociateId(associate_id)
      const { data } = await apiClient.get(`/api/document/associate/${safeAssociateId}/store`, {
        params: { associate_id: safeAssociateId, request_id }
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg ?? 'An error occurred while loading the document.'} `)
      }

      if (!data.document) {
        throw new Error('No document found')
      }

      return data.document
    } catch (error) {
      throw error.message
    }
  },

  async getAssociateDocument(_, { associate_id, document_id }) {
    try {
      const safeAssociateId = ensureAssociateId(associate_id)
      const { data } = await apiClient.get(`/api/document/associate/${safeAssociateId}/store/${document_id}`)

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      if (!data.document) {
        throw new Error('No previous version found')
      }

      return data.document
    } catch (error) {
      throw error.message
    }
  },

  async checkCreatedAssociateDocument(_, { associate_id, ids }) {
    try {
      const safeAssociateId = ensureAssociateId(associate_id)
      const { data } = await apiClient.get(`/api/document/associate/${safeAssociateId}/store/check_created`, {
        params: { ids }
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data.document
    } catch (error) {
      throw error.message
    }
  },

  async createAssociateDocument({ state, commit }, { document, associate_id }) {
    try {
      const safeAssociateId = ensureAssociateId(associate_id)
      const { data } = await apiClient.post(`/api/document/associate/${safeAssociateId}/store`, {
        document
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      if (state.associateDocuments) {
        const updatedDocuments = {
          ...state.associateDocuments,
          items: [data.document, ...(state.associateDocuments.items ?? [])]
        }

        commit('SET_ASSOCIATE_DOCUMENTS', updatedDocuments)
      }

      return data.document
    } catch (error) {
      throw error.message
    }
  },

  async patchAssociateDocument({ state, commit }, { document, associate_id }) {
    try {
      const safeAssociateId = ensureAssociateId(associate_id)
      const { data } = await apiClient.patch(`/api/document/associate/${safeAssociateId}/store`, {
        document
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data.document
    } catch (error) {
      throw error.message
    }
  },

  async createAssociateDocumentTemplate(_, { document, associate_id }) {
    try {
      const safeAssociateId = ensureAssociateId(associate_id)
      const { data } = await apiClient.post(`/api/document/associate/${safeAssociateId}/store`, {
        document
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data.document
    } catch (error) {
      throw error.message
    }
  },

  async deleteAssociateDocument(_, { document, associate_id }) {
    try {
      const safeAssociateId = ensureAssociateId(associate_id)
      const { data } = await apiClient.delete(`/api/document/associate/${safeAssociateId}/store/${document}`)

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }
    } catch (error) {
      throw error.message
    }
  },
  async bulkArchiveSignedInstances(_, { type, object_id }) {
    try {
      const { data } = await apiClient.post('/api/document/project/bulk_archive_signed', {
        type,
        object_id
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data.archived
    } catch (error) {
      throw error.message
    }
  },
  async archiveAssociateSignedDocument(_, { id }) {
    try {
      const { data } = await apiClient.post('/api/document/associate/archive', {
        id
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }
    } catch (error) {
      throw error.message
    }
  },

  // Templates

  setTemplates({ commit }, { payload }) {
    commit('SET_TEMPLATES', payload)
  },

  async getAssociateTemplates({ rootState }, { page = 1, size = 10, filters, cancelPreviousRequests = true }) {
    try {
      const project_id = rootState.applicationState.currentProject.id

      const { data } = await apiClient.get('/api/document/associate/template', {
        params: { page, size, ...filters, project_id },
        cancelPreviousRequests
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data
    } catch (error) {
      throw error.message
    }
  },

  async getAssociateTemplate(_, { template_id }) {
    try {
      const { data } = await apiClient.get(`/api/document/associate/template/${template_id}`)

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data.template
    } catch (error) {
      throw error.message
    }
  },

  async postAssociateTemplate(_, { template }) {
    try {
      const { data } = await apiClient.post('/api/document/associate/template', { template })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data.template
    } catch (error) {
      throw error.message
    }
  },

  async patchAssociateTemplate(_, { template_id, template }) {
    try {
      const { data } = await apiClient.patch(`/api/document/associate/template/${template_id}`, { template })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data.template
    } catch (error) {
      throw error.message
    }
  },

  async deleteAssociateTemplate(_, { template_id }) {
    try {
      const { data } = await apiClient.delete(`/api/document/associate/template/${template_id}`)

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }
    } catch (error) {
      throw error.message
    }
  },

  // dynamic documents

  setAssociateDynamicForm({ commit }, payload) {
    commit('SET_ASSOCIATE_DYNAMIC_FORM', {
      type: payload.type,
      data: payload.data
    })
  },

  async getDynamicTemplate({ rootState }, { type, associate_id }) {
    const project_id = rootState.applicationState.currentProject.id

    try {
      const { data } = await apiClient.get('/api/project/dynamic_form', {
        params: {
          project_id,
          type,
          associate_id
        }
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data.form
    } catch (error) {
      throw error.message
    }
  },

  async getAvailabilityDynamicForm({ commit }, { associate_id }) {
    try {
      const { data } = await apiClient.get('/api/project/dynamic_form/available_forms', {
        params: {
          associate_id
        }
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      commit('SET_ASSOCIATE_DYNAMIC_FORM_AVAILABILITY', data.forms)
    } catch (error) {
      throw error.message
    }
  },

  async getDynamicForm({ commit }, { type, associate_id }) {
    try {
      const { data } = await apiClient.get('/api/project/dynamic_form/answers', {
        params: {
          associate_id,
          type
        }
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      commit('SET_ASSOCIATE_DYNAMIC_FORM', {
        type: type,
        data: data.answers
      })
    } catch (error) {
      throw error.message
    }
  },

  async postDynamicForm({ rootState }, { form }) {
    const author_id = rootState.applicationState.associate.id

    try {
      const { data } = await apiClient.post('/api/project/dynamic_form/answers', {
        ...form,
        author_id
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data.answers
    } catch (error) {
      throw error.message
    }
  }
}
